export const assistantGetterTypes = {
    GET_CONVERSATION_ID: 'assistant/GET_CONVERSATION_ID',
    GET_CLIENT_ID: 'assistant/GET_CLIENT_ID',
    GET_MESSAGES: 'assistant/GET_MESSAGES',
    GET_OUTGOING: 'assistant/GET_OUTGOING',
    GET_TURN_STATE: 'assistant/GET_TURN_STATE',
    GET_PENDING: 'assistant/GET_PENDING',
    GET_CLIENT_CANDIDATES: 'assistant/GET_CLIENT_CANDIDATES',
    GET_WIG: 'assistant/GET_WIG',
    GET_IS_SENDING: 'assistant/GET_IS_SENDING',
    GET_FAILURE: 'assistant/GET_FAILURE',
    GET_IS_SWITCHED_OFF: 'assistant/GET_IS_SWITCHED_OFF',
    GET_CAN_RETRY: 'assistant/GET_CAN_RETRY',
    GET_HAS_CONVERSATION: 'assistant/GET_HAS_CONVERSATION',
}

export const assistantMutationTypes = {
    SET_TURN: 'assistant/SET_TURN',
    APPEND_TURN: 'assistant/APPEND_TURN',
    SET_OUTGOING: 'assistant/SET_OUTGOING',
    SET_SENDING: 'assistant/SET_SENDING',
    SET_FAILURE: 'assistant/SET_FAILURE',
    SET_SWITCHED_OFF: 'assistant/SET_SWITCHED_OFF',
    SET_CLIENT_ID: 'assistant/SET_CLIENT_ID',
    CLEAR_CLIENT_CANDIDATES: 'assistant/CLEAR_CLIENT_CANDIDATES',
    SET_LAST_TURN: 'assistant/SET_LAST_TURN',
    RESET: 'assistant/RESET',
}

export const assistantActionTypes = {
    OPEN: 'assistant/OPEN',
    SEND_TURN: 'assistant/SEND_TURN',
    RETRY: 'assistant/RETRY',
    SELECT_CLIENT: 'assistant/SELECT_CLIENT',
    CONFIRM_CREATE_CLIENT: 'assistant/CONFIRM_CREATE_CLIENT',
    START_OVER: 'assistant/START_OVER',
    RESET: 'assistant/RESET',
}
